import { useEffect, useState } from "react";
import {
  GetUserName,
  GetPerkByID,
  GetSkillByID,
  GetPerkImage,
  GetSkillImage,
} from "../../Database/Functions";
import Icon from "../../UI/Icon/Icon";
import IconList from "../../UI/IconList/IconList";
import Buttton from "../../UI/Button/Button";
import Card from "../../UI/Card/Card";

const ContractItem = (props) => {
  const [userClaimedName, setUserClaimedName] = useState();
  const [userPartyName, setUserPartyName] = useState("-");
  const [perkIcon, setPerkIcon] = useState();
  const [skillIcon, setSkillIcon] = useState();
  const contract = props.contract;
  const dateOpen = new Date(contract.dateOpen);
  const dateUpdated = new Date(contract.dateUpdated);

  function closeContractHandler() {
    props.onCloseContract(contract.id, contract.party);
  }

  function assignContractHandler() {
    props.onAssignContract(contract.id, Object.keys(contract.claims)[0]);
  }

  function declineClaimHandler() {
    props.onDeclineContract(contract.id, contract.party);
  }

  useEffect(() => {
    if (contract.party) {
      GetUserName(contract.party).then((name) => {
        setUserPartyName(name);
      });
    }
  }, []);

  useEffect(() => {
    GetPerkByID(contract.rewardperk)
      .then((p) => {
        setPerkIcon(p);
      })
      .catch((e) => {});
    GetSkillByID(contract.rewardskil)
      .then((s) => {
        setSkillIcon(s);
      })
      .catch((e) => {});
  }, []);

  const contractStatuses = ["открыта", "в работе", "завершено"];

  function getContractStatus(status) {
    if (!status && status != 0) return "Ошибка";
    return contractStatuses[+status];
  }
  function getContractActions() {
    let claimed = false;
    let userClaimed;
    if (contract.claims) {
      userClaimed = Object.keys(contract.claims)[0]; //TODO: сделать вывод нескольких
      claimed = true;
      GetUserName(userClaimed).then((p) => {
        setUserClaimedName(p);
      });
    }
    switch (+contract.status) {
      case 0: //  открыта задача
        if (claimed) {
          return (
            <>
              <Buttton className="" onClick={assignContractHandler} size="s">
                Назначить на {userClaimedName}
              </Buttton>
              <Buttton className="" onClick={declineClaimHandler} size="s">
                Отклонить
              </Buttton>
            </>
          );
        } else {
          return (
            <></>
            // <Buttton
            //   disabled  onClick={closeContractHandler} size="s" >
            //   Назначить
            // </Buttton>
          );
        }

      case 1: //  задача взята(назначена)
        return (
          <Buttton className="" onClick={closeContractHandler} size="s">
            Принять работу
          </Buttton>
        );

      default:
        return;
    }
  }
  return (
    <Card
      className="Cards-list__item"
      size="small"
      state={contract.status < 2 ? "default" : "inactive"}
    >
      Назначен: {"partyName" in contract ? contract.partyName : "нет"}
      <br />
      Открыта: {dateOpen.toLocaleDateString()}
      <br />
      Условия: {contract.terms}
      <br />
      Статус: {getContractStatus(contract.status)} (
      {dateUpdated.toLocaleDateString()})
      <br />
      <IconList className="Card__section">
        {"rewardPrice" in contract && contract.rewardPrice ? (
          <Icon
            className="Card__icon Icon-list__item"
            image="baf"
            size="m2" //custom for this icon
            title={contract.rewardPrice}
          />
        ) : (
          ""
        )}
        {"rewardperk" in contract && contract.rewardperk ? (
          <Icon
            className="Card__icon Icon-list__item"
            image={contract.rewardperkIcon}
            size="s"
            title={""}
          />
        ) : (
          ""
        )}
        {"rewardskil" in contract && contract.rewardskil ? (
          <Icon
            className="Card__icon Icon-list__item"
            image={contract.rewardskilIcon}
            size="s"
            title={""}
          />
        ) : (
          ""
        )}
      </IconList>
      {getContractActions()}
    </Card>
  );
};

export default ContractItem;
